import type { LoginSuccessCallbackType } from '../type'
import { useUserInfo } from '~/composables/app'

const { authLogin, authTronLogin, authTelegramLogin, authGoogleOAuthSignIn } = apis

/**
 * @description: 获取登录方法
 */
export function useLoginApiActions(callback?: LoginSuccessCallbackType) {
  const { t } = useI18n()
  const { userInfo, userInfoQuerier } = useUserInfo()

  async function afterLoginAction() {
    await userInfoQuerier.refetch()
    const user = userInfo.value
    user && aMessage.success(`${t('f6dJkcNH1Ez26bApJknu')}：${user.account}`)
    callback?.(user)
    return user
  }

  function generateLoginFn<T extends Api.Request>(fn: T) {
    return async (params: Api.GetParam<T>['requestBody']) => {
      try {
        await fn({ requestBody: params }, { errorMessageMode: 'none' })
        return afterLoginAction()
      }
      catch (error) {
        return Promise.reject(error)
      }
    }
  }

  /** 邮箱登录 */
  const emailLogin = generateLoginFn(authLogin)

  /** 钱包一键登录 */
  const tronLogin = generateLoginFn(authTronLogin)

  /** Telegram一键登录 */
  const telegramLogin = generateLoginFn(authTelegramLogin)

  /** Google一键登录 */
  async function googleLogin(
    params: Api.GetParam<typeof authGoogleOAuthSignIn>['requestBody'],
  ) {
    let errData: any = null
    const res: any = await authGoogleOAuthSignIn(
      { requestBody: params },
      { errorMessageMode: 'none', resultType: 'axios' },
    ).catch((err) => {
      errData = err
    })
    return res?.data?.code === 0 ? await afterLoginAction() : Promise.reject(errData || res)
  }

  return { emailLogin, tronLogin, telegramLogin, googleLogin }
}
